/**
 * Index template
 * This file contains logic specific to a template.
 * It is intended to ONLY be loaded on templates that require
 * this specific functionality.
 **/

import Global from './lib/global';
import Logger from './lib/logger';

// Vars
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

const NAME = 'Index';

let currentPaginationPage = 1;

const loadMoreButtonDom = document.querySelector(`[data-load-more-button]`);

const blogGridDom = document.querySelector(`[data-blog-grid]`);

// Logic
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

/**
 * init - Initialize the page
 **/
const init = () => {
	Logger.log(`${NAME} > loaded`);
	initLoadMoreButton();
}

/**
 * initLoadMoreButton - Initialize the load more button
 */
const initLoadMoreButton = () => {
	Logger.info(`${NAME} > initLoadMoreButton`);

	if (!loadMoreButtonDom) return;

	loadMoreButtonDom.addEventListener('click', (event) => {
		event.preventDefault();
		loadMorePosts();
	});
}

/**
 * loadMorePosts - Load more posts
 */
const loadMorePosts = async () => {
	Logger.info(`${NAME} > loadMorePosts`);

	if (!blogGridDom) return;

	currentPaginationPage++;

	let html = '';

	// Make a WordPress Ajax request to load more posts
	let _data = {
		action: 'wonder_load_more_blog_articles',
		nonce: window.global_vars.ajax_nonce,
		paged: currentPaginationPage,
	};

	// Make the request
	let response = await fetch(window.global_vars.ajax_url, {
		method: 'POST',
		body: (new URLSearchParams(_data)).toString(),
		headers: { 'Content-type': 'application/x-www-form-urlencoded' }
	});
	let data = await response.json();

	if (data.success && data.data.html) {
		html = data.data.html;
	}

	// If no posts were returned, stop
	if (html === '') {
		// Hide the load more button
		loadMoreButtonDom.style.display = 'none';
	}

	// Append the new posts to the container
	blogGridDom.insertAdjacentHTML('beforeend', html);
}

// Bootstrap global functionality
Global();

// Bootstrap page-specific functionality
init();

// Do not edit below this line...
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
Logger.log(`${NAME} > loaded`);
